export default "__VITE_ASSET__523b02f1__"